// Загрузка доступных устройств
export const READINGS_DEVICES_REQUEST =
    "readings/DEVICES_REQUEST";

export const READINGS_DEVICES_SUCCESS =
    "readings/DEVICES_SUCCESS";

export const READINGS_DEVICES_FAILURE =
    "readings/DEVICES_FAILURE";

// Загрузка показаний
export const READINGS_DATA_REQUEST =
    "readings/DATA_REQUEST";

export const READINGS_DATA_SUCCESS =
    "readings/DATA_SUCCESS";

export const READINGS_DATA_FAILURE =
    "readings/DATA_FAILURE";

// Применение фильтра
export const READINGS_FILTER_APPLY =
    "readings/FILTER_APPLY";

// Очистка состояния страницы
export const READINGS_RESET =
    "readings/RESET";